import "date-fns";
import React, { useState, useEffect } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField } from "@mui/material";
import { es } from "date-fns/locale";

const PickerTextField = React.forwardRef(function PickerTextField(
  tfProps,
  ref
) {
  const { inputProps: inputPropsFromPicker, inputRef, ...rest } = tfProps;
  return (
    <TextField
      {...rest}
      ref={ref}
      inputRef={inputRef}
      autoComplete="off"
      name={`datepicker-${rest.id || "nohistory"}`}
      inputProps={{
        ...inputPropsFromPicker,
        autoComplete: "new-password",
        autoCorrect: "off",
        spellCheck: false,
        inputMode: "numeric",
        pattern: "\\d*",
      }}
    />
  );
});

//usar forwardRef ?
const DatePickerCustom = ({
  fullWidth,
  onChange,
  onKeyDown,
  value,
  minDate,
  maxDate,
  className,
  label,
  id,
  error,
  onBlur,
  reference,
  readOnly = false,
}) => {
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = useState(value);
  //const [showError, setShowError] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (onChange) onChange(date);
  };

  const handleBlur = () => {
    if (onBlur) onBlur();
  };

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
      <DatePicker
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        minDate={minDate}
        maxDate={maxDate}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            fullWidth={fullWidth}
            margin="normal"
            id={id}
            error={error}
            onBlur={handleBlur}
            onKeyDown={onKeyDown}
            sx={{
              "& .MuiInputAdornment-root": {
                marginRight: "15px",
              },
            }}
            inputProps={{
              ...params.inputProps,
              readOnly: readOnly
            }}
          />
        )}
        TextFieldComponent={PickerTextField}
        PopoverProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
